<template>
  <div class="row mt-3 mb-4">
    <div class="col-12 mb-3">
      <SectionTitle content="Información General" :has-line="true" />
    </div>
    <div class="col-12 mb-2">
      <div class="row rounded mx-0 mb-05 greenish">
        <div class="col-12 py-3 pl-4">
          <label class="mb-1">Fecha:</label>
          <ValidationProvider
            v-slot="{ errors }"
            slim
            name="date"
            rules="required"
          >
            <CustomDatePicker
              v-model="model.date"
              :max-date="maxDate"
              :disabled="readonly"
              :error="errors[0]"
              :custom-error-msg="'Favor registrar fecha'"
              required
            />
          </ValidationProvider>
        </div>
      </div>
      <div class="row grayish m-0 py-3 rounded">
        <div class="col-12 pl-4 mb-2">
          <strong>Certificación de los escenarios</strong>
        </div>
        <div class="col-12 pl-4">
          <section class="bg-white p-3 border">
            <p class="font-weight-normal">
              La información general del caso de Rosa Lydia Vélez vs DE, indica
              lo siguiente:
              <strong>
                "La Asistencia Tecnológica se utiliza para ayudar a mejorar,
                mantener o aumentar la capacidad funcional de los estudiantes
                con impedimentos. Esta se puede proveer en la escuela, el hogar
                y en centros de terapias, en los casos apropiados, como
                resultado de las evaluaciones y recomendaciones de cada caso".
              </strong>
            </p>
            <p class="font-weight-normal mb-0">
              Como parte del cumplimiento con esta estipulación, el DE debe
              evidenciar que los equipos se utilizan en los ambientes donde el
              COMPU escolar estableció que eran necesarios. Por lo que es
              sumamente importante cumplimentar la siguiente información y
              hacerla llegar al CSEE que corresponda de acuerdo a su ubicación
              escolar. Cualquier duda debe comunicarse al Comité Asesor de
              Asistencia Tecnológica (CAAT) correspondiente.
            </p>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { SectionTitle } from '@/components/pei/shared';

import CustomDatePicker from '@/components/common/CustomDatePicker';
import { ValidationProvider } from 'vee-validate';
export default {
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      maxDate: new Date(),
    };
  },
  components: {
    CustomDatePicker,
    ValidationProvider,
    SectionTitle,
  },
  methods: {},
};
</script>
<style scoped>
p {
  font-size: 14px;
  color: #727272;
}
.mb-05 {
  margin-bottom: 0.15rem;
}
.greenish {
  background-color: #d9e5df;
}
.grayish {
  background-color: #f2f2f2;
}
</style>
